import React from "react";
import CLLTableHeadFormik from "./CLLTableHeadFormik";
import CCLTableBodyFormik from "./CCLTableBodyFormik";
import Table from "@mui/material/Table";
import { useFormikContext } from "formik";
import { Alert, Grid } from "@mui/material";

function EnhancedTableToolbar(props) {
  const { name, label } = props;
  const { errors } = useFormikContext();
  return (
    <>
      {errors[name + "_Label"] && (
        <Alert severity="error">
          <span> {errors[name + "_Label"]} </span>
        </Alert>
      )}

      <u>
        <b>{label}:</b>
      </u>
    </>
  );
}

export function CCLTableFormik(props) {
  return (
    <>
      <div className="tableformik">
        <EnhancedTableToolbar {...props} />
        <Grid maxWidth="sm">
          <Table>
            <CLLTableHeadFormik {...props}></CLLTableHeadFormik>
            <CCLTableBodyFormik {...props}></CCLTableBodyFormik>
          </Table>
        </Grid>
      </div>
    </>
  );
}
